/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterUserQueryKind = (typeof FilterUserQueryKind)[keyof typeof FilterUserQueryKind];

export const FilterUserQueryKind = {
  user_query: 'user_query',
} as const;
